export default {
  list: [
    {
      title: 'فعال',
      value: 'ACTIVE'
    },
    {
      title: 'غیر فعال',
      value: 'DEACTIVE'
    },
  ],
  values: {
    ACTIVE: 'ACTIVE',
    DEACTIVE: 'DEACTIVE',
  }
};
